// extracted by mini-css-extract-plugin
export default {"PartnersBlock":"Partners_PartnersBlock__CzTNP","container":"Partners_container__b1UH9","innerWrap":"Partners_innerWrap__THD3v"};